import React from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import ProductForm from './ProductForm';

const CreateProductModal = ({isOpen, toggle, refreshList, product}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} centered={true}>
            <ModalHeader toggle={toggle}>
                <strong>Edit Product</strong>
            </ModalHeader>
            <ProductForm
                type="edit"
                toggle={toggle}
                refreshList={refreshList}
                existingProduct={product}
            />
        </Modal>
    );
};

export default CreateProductModal;
